import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

export const noticeHttpError = createAction(
  "[Global] Notice http error",
  props<{ error: HttpErrorResponse }>()
);
